import React, { useState } from "react";
import { Section, SectionTitle, Reveal } from "../components/Section";
import { Copy, Wallet } from "lucide-react";
import { toast } from "sonner";
import { WEDDING_CONFIG } from "../config";

const FlipCard = ({ bank, number, name, delay }) => {
  const [flipped, setFlipped] = useState(false);

  const copy = async (e) => {
    e.stopPropagation();
    try {
      await navigator.clipboard.writeText(number);
      toast.success(`Nomor rekening ${bank} disalin`);
    } catch {
      // Fallback for non-secure contexts
      const ta = document.createElement("textarea");
      ta.value = number;
      document.body.appendChild(ta);
      ta.select();
      try { document.execCommand("copy"); toast.success(`Nomor rekening ${bank} disalin`); }
      catch { toast.error("Gagal menyalin"); }
      document.body.removeChild(ta);
    }
  };

  return (
    <Reveal delay={delay}>
      <div
        className={`flip-card ${flipped ? "flipped" : ""} h-56 cursor-pointer`}
        onClick={() => setFlipped(!flipped)}
        data-testid={`envelope-${bank.toLowerCase()}`}
      >
        <div className="flip-inner">
          <div className="flip-face bg-gradient-to-br from-ivory via-cream to-gold-light border border-gold/40 flex flex-col items-center justify-center p-6">
            <Wallet size={28} className="text-gold mb-3" />
            <p className="text-xs tracking-[0.3em] uppercase text-gold mb-2">Amplop Digital</p>
            <p className="font-serif text-2xl text-charcoal">{bank}</p>
            <p className="text-xs text-charcoal/60 mt-3 italic">Tekan untuk membuka</p>
          </div>
          <div className="flip-face flip-back bg-white border border-gold/40 flex flex-col items-center justify-center p-6 text-center">
            <p className="text-xs tracking-[0.3em] uppercase text-gold mb-2">{bank}</p>
            <p className="font-serif text-2xl text-charcoal tracking-wider mb-1" data-testid={`account-number-${bank.toLowerCase()}`}>
              {number}
            </p>
            <p className="text-sm text-charcoal/70 mb-4">a.n. {name}</p>
            <button
              type="button"
              onClick={copy}
              data-testid={`copy-${bank.toLowerCase()}`}
              className="inline-flex items-center gap-2 text-xs tracking-[0.2em] uppercase text-gold hover:text-gold-dark border border-gold/40 px-4 py-2"
            >
              <Copy size={14} /> Salin Nomor
            </button>
          </div>
        </div>
      </div>
    </Reveal>
  );
};

export default function Envelope() {
  return (
    <Section testId="envelope-section" className="bg-ivory">
      <SectionTitle overline="Wedding Gift" title="Amplop" italic="Digital" />

      <Reveal>
        <p className="text-center text-charcoal/70 max-w-lg mx-auto mb-10 font-serif italic">
          Doa restu Anda adalah hadiah terindah. Namun bila berkenan memberi tanda kasih,
          kami sediakan amplop digital berikut.
        </p>
      </Reveal>

      <div className="grid grid-cols-1 max-w-md mx-auto">
        {WEDDING_CONFIG.accounts.map((a, i) => (
          <FlipCard key={a.bank} {...a} delay={i * 0.15} />
        ))}
      </div>
    </Section>
  );
}
